import _ from 'lodash';

import Err from 'models/err';
import { getValidationErrors } from 'models/phone_number';
import UpdateProfileActionBase from './update_profile_action_base';

export default class AddPhoneNumber extends UpdateProfileActionBase {
  _update(profile, attrs) {
    this.context.analytics.track('Customer Page - Save Phone Number to Profile From Conversation Item');
    profile.addPhoneNumber(attrs);
    return _.pick(profile, 'phones');
  }

  _getValidationErrors(attrs) {
    const { index } = attrs;
    const errs = getValidationErrors(attrs);

    return errs.map(
      err =>
        new Err({
          code: err.code,
          attr: `phones.${index}.${err.attr}`,
          detail: err.detail,
        })
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_profile/add_phone_number.js